export const currency = {
  // Currency dropdown
  currencySearch: "Buscar moneda...",
  currencyFiatOnly: "Solo Fiat",
  currencyManage: "Administrar",
  currencySelectCurrency: "Seleccionar moneda",
  currencyNoResults: "No se encontraron monedas",
  currencyTypeFiat: "Fiat",
  currencyTypeCrypto: "Cripto",

  // Currency management modal
  currencyManageTitle: "Administrar Monedas",
  currencyManageFiatTab: "Dinero Fiat",
  currencyManageCryptoTab: "Criptomonedas",
  currencyManageSearchPlaceholder: "Buscar en {type}...",
  currencyManageNoFiat: "No se encontraron monedas fiat",
  currencyManageNoCrypto: "No se encontraron criptomonedas",
  currencyManageClose: "Cerrar",

  currencyName: "Monedas",
  cryptoNames: "Criptos",

  // Currency names
  currencyVES: "Bolívares",
  currencyUSD: "Dólares",
  currencyUSDT: "Tether USD",
  currencyCLP: "Pesos Chilenos",

  // Currency symbols
  currencySymbolVES: "Bs.",
  currencySymbolUSD: "$",
  currencySymbolUSDT: "₮",
  currencySymbolCLP: "$",

  // Conversion
  currencyConversionError: "Error al convertir moneda",
  currencyLoadingRates: "Cargando tasas de cambio...",
  currencyManagementNote: "Habilita o deshabilita monedas para mostrar en el dropdown",
};
